import React from "react";
import "./Workshop.css";

export default function WorkshopCard({ image, title, description, location, date }) {
  return (
    <div className="workshop-card-official">
      {image && (
        <div className="workshop-image">
          <img src={image} alt={title} />
        </div>
      )}

      <div className="workshop-content">
        <h3 className="workshop-title">{title}</h3>

        <p className="workshop-description">{description}</p>

        <div className="workshop-meta">
          <span>{location}</span>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );
}
